import { NgClass } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DeviceAttribute } from '@devices';
import { NoDataPlaceholderComponent, SearchInputComponent } from '@ui';

export type DataPointAttribute = Pick<DeviceAttribute, 'attributeType' | 'name'> & {
  measurementUnit?: DeviceAttribute['measurementUnit'];
}

@Component({
  imports: [SearchInputComponent, NoDataPlaceholderComponent, MatCheckboxModule, FormsModule, MatSlideToggleModule, NgClass],
  selector: 'avs-data-point-selector',
  styles: `
    :host {
      position: relative;
      display: block;
    }
  `,
  templateUrl: './data-points-selector.component.html',
})
export class DataPointSelectorComponent {
  availablePoints = input.required<DataPointAttribute[]>();
  selectedPoints = input.required<DataPointAttribute[]>();
  toggleCssClass = input('mb-5');
  isRealtime = input(true);

  selectedPointsChange = output<DataPointAttribute[]>();

  protected search = signal('');
  protected showSelectedOnly = signal(false);

  protected pointsToRender = computed(() => {
    const showSelectedOnly = this.showSelectedOnly();
    const search = this.search().toLowerCase();
    const selectedNames = new Set(this.selectedPoints().map(p => p.name));
    const allPointsWithState = this.availablePoints().map(point => ({
      ...point,
      checked: selectedNames.has(point.name),
    }));

    return allPointsWithState
      .filter(point => !showSelectedOnly || point.checked)
      .filter(point => !search || point.name.toLowerCase().includes(search));
  });

  protected onSelectionChange(point: DataPointAttribute & { checked: boolean }, checked: boolean) {
    const changedPointName = point.name;
    const currentSelected = this.selectedPoints();
    const withoutChangedPoint = currentSelected.filter(p => p.name !== changedPointName);

    this.selectedPointsChange.emit(checked ? [...withoutChangedPoint, point] : withoutChangedPoint);
  }
}
